import React, { useEffect, useState } from "react";
import { Alert, Collapse, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface AlertMessageProps {
  message: string;
  type: "error" | "warning" | "info" | "success";
  auto_close: boolean;
  view?: boolean;
}

const AlertMessage: React.FC<AlertMessageProps> = ({ message, type, auto_close, view = true }) => {
  const [open, setOpen] = useState(view);

  useEffect(() => {
    if (auto_close) {
      if (view) {
        setOpen(true);
        const timer = setTimeout(() => setOpen(false), 2000); // Fecha o alerta após 2 segundos
        return () => clearTimeout(timer); // Limpa o timer se `view` mudar antes do tempo acabar
      } else {
        setOpen(false);
      }
    }
  }, [view]); // Depende apenas de `view`

  return (
    <>
      {!auto_close && open && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo semi-transparente
            zIndex: 1299, // Um nível abaixo do alerta
          }}
        />
      )}
      <Collapse in={open}>
        <Alert
          severity={type}
          action={
            !auto_close && (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => setOpen(false)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            )
          }
          sx={{
            mb: 2,
            position: "fixed",
            top: "0%", // Distância do topo
            left: 0, // Inicia do lado esquerdo
            width: "100%", // Ocupa toda a largura
            zIndex: 1300, // Alta prioridade para exibir sobre outros elementos
            textAlign: "center", // Centraliza o conteúdo do texto (opcional)
          }}
        >
          {message}
        </Alert>
      </Collapse>
    </>
  );
};

export default AlertMessage;
